const actionTypes = {
    SET_EVENTS: 'SET_EVENTS',
    SET_APPLIED_EVENTS_FILTERS: 'SET_APPLIED_EVENTS_FILTERS',
    SET_IS_LOADING: 'SET_IS_LOADING',
    UPDATE_EVENTS: 'UPDATE_EVENTS',
    SET_STORES_LIST: 'SET_STORES_LIST',
    UPDATE_LOCATION_FILTERS: 'UPDATE_LOCATION_FILTERS',
    SET_CURRENT_LOCATION: 'SET_CURRENT_LOCATION'
};

module.exports = actionTypes;
